import { FaBriefcase } from "react-icons/fa";
import { PiCarBold } from "react-icons/pi";

const cabTabs = [
  {
    label: "Out Station",
    value: "OutStationDay",
    icon: <FaBriefcase />,
  },
  {
    label: "Local Trip",
    value: "Local",
    icon: <PiCarBold />,
  },
];

const Loader = () => (
  <tr>
    <td colSpan="100%" className="text-center py-6">
      <div className="flex justify-center items-center space-x-2">
        <div className="w-4 h-4 rounded-full animate-ping bg-blue-500" />
        <div className="w-4 h-4 rounded-full animate-ping bg-blue-500 delay-150" />
        <div className="w-4 h-4 rounded-full animate-ping bg-blue-500 delay-300" />
        <span className="ml-3 text-gray-500">Loading...</span>
      </div>
    </td>
  </tr>
);
const localTripTabsDetails = [
  {
    label: "10 Hrs",
    icon: <PiCarBold />,
    value: "10",
  },
  {
    label: "8 Hrs",
    value: "8",
    icon: <PiCarBold />,
  },
  {
    label: "4 Hrs",
    value: "4",
    icon: <PiCarBold />,
  },
];
const outStationTrips = [
  {
    label: "Out Station - Day Basis",
    value: "OutStationDay",
  },
  {
    label: "Out Station - Km Basis",
    value: "OutStationKm",
  },
];

export { cabTabs,Loader, localTripTabsDetails, outStationTrips };
